import React, { useState, useEffect, useCallback } from 'react';
import { relationshipAPI } from '../services/api';
import AddRelativeModal from './AddRelativeModal';
import './RelationsSection.css';

function RelationsSection({ member, allMembers }) {
  const [relations, setRelations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const fetchRelations = useCallback(async () => {
    if (!member?.id) return;
    try {
      const response = await relationshipAPI.getAll(member.id);
      setRelations(response.data);
    } catch (err) {
      console.error('Failed to fetch relations:', err);
    } finally {
      setLoading(false);
    }
  }, [member?.id]);

  useEffect(() => {
    fetchRelations();
  }, [fetchRelations]);

  const handleRemove = async (relationId) => {
    try {
      await relationshipAPI.delete(relationId);
      setRelations(relations.filter(r => r.id !== relationId));
    } catch (err) {
      console.error('Failed to remove relation:', err);
    }
  };

  const handleModalSave = () => {
    setShowModal(false);
    fetchRelations();
  };

  const getRelationDisplay = (relation) => {
    const isFirst = relation.person1_id === member.id;
    const otherPersonId = isFirst ? relation.person2_id : relation.person1_id;
    const otherPerson = allMembers.find(m => m.id === otherPersonId);

    let relType = relation.relationship_type;
    // Adjust display based on direction
    if (relType === 'parent') {
      relType = isFirst ? 'child' : 'parent';
    }

    const name = otherPerson
      ? `${otherPerson.first_name} ${otherPerson.last_name || ''}`.trim()
      : 'Unknown';

    return { name, type: relType, id: relation.id };
  };

  if (loading) {
    return <div className="relations-loading">Loading relations...</div>;
  }

  return (
    <div className="relations-section">
      {relations.length === 0 ? (
        <p className="relations-empty">No relations added yet.</p>
      ) : (
        <ul className="relations-list">
          {relations.map((relation) => {
            const display = getRelationDisplay(relation);
            return (
              <li key={relation.id} className="relation-item">
                <span className="relation-name">{display.name}</span>
                <span className="relation-type">({display.type})</span>
                <button
                  type="button"
                  className="relation-remove"
                  onClick={() => handleRemove(display.id)}
                  aria-label={`Remove ${display.name}`}
                >
                  ×
                </button>
              </li>
            );
          })}
        </ul>
      )}

      <button
        type="button"
        className="add-relation-btn"
        onClick={() => setShowModal(true)}
      >
        + Add relation
      </button>

      {showModal && (
        <AddRelativeModal
          member={member}
          onClose={() => setShowModal(false)}
          onSave={handleModalSave}
        />
      )}
    </div>
  );
}

export default RelationsSection;
